<template>
  <button v-on:click.prevent="$emit('clearForm')" class="form__newsletter__confirmation" aria-label="You are now subscribed.">
    <span class="form__newsletter__confirmation__text">You are now subscribed.</span>
    <svg xmlns="http://www.w3.org/2000/svg" class="form__newsletter__btn__svg" v-bind:class="getClass()" viewBox="0 0 24 24" stroke="#000" stroke-width="4">
      <path d="M1.5 22.5l21-21m-21 0l21 21" vector-effect="non-scaling-stroke" />
    </svg>
  </button>
</template>

<script>

export default {
  props: ["useAccentColor"],
  methods: {
    getClass() {
      if (this.useAccentColor) {
        return "accent-color";
      }
    }
  }
}
</script>
